import React from "react";
import { SHOW_NIGHT } from "../../mock/mock";
import { Sparkles } from "lucide-react";

export default function ShowNight() {
  return (
    <section id="show-night" className="relative bg-[#1a1a1a] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: "radial-gradient(1000px 400px at 20% 0%, rgba(193,39,45,0.35), transparent 60%), radial-gradient(800px 400px at 80% 100%, rgba(58,111,112,0.35), transparent 60%)" }} />
      <div className="relative max-w-6xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="eyebrow text-lg" style={{ color: "#e6c88a" }}>{SHOW_NIGHT.eyebrow}</p>
          <div className="mx-auto mt-3 h-px w-14 bg-[#e6c88a]" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight">{SHOW_NIGHT.heading}</h2>
          <p className="mt-4 text-white/70">{SHOW_NIGHT.sub}</p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {SHOW_NIGHT.points.map((p) => (
            <div key={p.n} className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-6 md:p-7 lift">
              <div className="font-serif-display italic text-4xl md:text-5xl text-[#e6c88a]">{p.n}</div>
              <h3 className="mt-3 font-serif-display text-2xl">{p.title}</h3>
              <p className="mt-2 text-white/75 text-[14.5px] leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 text-white/60 text-sm">
          <Sparkles size={16} className="text-[#e6c88a]" />
          <span>Show Night — 22 November 2026 · 5–8pm · Sydney</span>
        </div>
      </div>
    </section>
  );
}
